var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsis"},[_c('div',{class:_vm.white?'bg-white':'bg-gray-800'}),_c('div',{class:_vm.white?'bg-white':'bg-gray-800'}),_c('div',{class:_vm.white?'bg-white':'bg-gray-800'}),_c('div',{class:_vm.white?'bg-white':'bg-gray-800'})])
}
var staticRenderFns = []

export { render, staticRenderFns }